// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_BuscarOrcamentosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /agenda/buscar_orcamentos
 *
 * Returns list of approved orcamentos with services. See
 * Agenda_BuscarOrcamentosRow for per-row shape (orcamentos.* + cliente
 * aliases + localidade_nome injection + nested servicos[] + counters).
 */
import type { Agenda_BuscarOrcamentosRow } from './Agenda_BuscarOrcamentosRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Agenda_BuscarOrcamentosResponseDados {
orcamentos: Agenda_BuscarOrcamentosRow[]
}

export type Agenda_BuscarOrcamentosResponse = ApiResponse<Agenda_BuscarOrcamentosResponseDados>;

registerResponseContract('Agenda_BuscarOrcamentosResponse', {
  orcamentos: {
    type: 'array',
    required: true,
    items: {
      orcamento_id:               { type: 'number',  required: true },
      orcamento_franquia_id:      { type: 'number',  required: true },
      orcamento_user_id:          { type: 'string',  required: false },
      orcamento_location_id:      { type: 'number',  required: false },
      orcamento_location_type:    { type: 'string',  required: false },
      orcamento_valor:            { type: 'number',  required: false },
      orcamento_origem:           { type: 'number',  required: false },
      orcamento_data:             { type: 'string',  required: false },
      orcamento_status:           { type: 'string',  required: true },
      orcamento_observacao:       { type: 'string',  required: false },
      orcamento_cliente_id:       { type: 'number',  required: false },
      orcamento_data_cadastro:    { type: 'string',  required: false },
      cliente_location_id:        { type: 'number',  required: false },
      cliente_location_type:      { type: 'string',  required: false },
      orcamento_cliente_nome:     { type: 'string',  required: false },
      orcamento_cliente_ddi:      { type: 'string',  required: false },
      orcamento_cliente_ddd:      { type: 'string',  required: false },
      orcamento_cliente_telefone: { type: 'string',  required: false },
      orcamento_rua:              { type: 'string',  required: false },
      orcamento_cep:              { type: 'string',  required: false },
      orcamento_numero:           { type: 'string',  required: false },
      orcamento_bairro:           { type: 'string',  required: false },
      localidade_nome:            { type: 'string',  required: false },
      servicos_total:             { type: 'number',  required: false },
      servicos_concluidos:        { type: 'number',  required: false },
      servicos_pendentes:         { type: 'number',  required: false },
      servicos: {
        type: 'array',
        required: false,
        items: {
          orcamento_servico_id:            { type: 'number',  required: true },
          orcamento_id:                    { type: 'number',  required: false },
          servico_id:                      { type: 'number',  required: false },
          servico_valor:                   { type: 'number',  required: false },
          orcamento_servico_qtd:           { type: 'number',  required: false },
          orcamento_servico_user_id:       { type: 'string',  required: false },
          orcamento_servico_tipo:          { type: 'number',  required: false },
          orcamento_servico_status:        { type: 'number',  required: true },
          orcamento_servico_data_cadastro: { type: 'string',  required: false },
          orcamento_franquia_id:           { type: 'number',  required: true },
          servico_nome:                    { type: 'string',  required: true },
          servicoscategoria_id:            { type: 'number',  required: false },
        },
      },
    },
  },
})
